enum considerType {
    fullBoard = 1, //แบบเต็มขั้นตอน	Full Board
    expedited = 2, //แบบลดขั้นตอน	Expedited
    exempt = 3, //แบบยกเว้น	Exempt
}
export default considerType
